var map = {
	"./assignment.js": "ed6d",
	"./auth.js": "11c0",
	"./batch.js": "44fb",
	"./blog.js": "9135",
	"./category.js": "a1f3",
	"./college.js": "74cb",
	"./collegeClass.js": "d1dd",
	"./common.js": "1d29",
	"./course.js": "6bfe",
	"./dashboard.js": "d959",
	"./department.js": "a1b1",
	"./domain.js": "34ae",
	"./email.js": "208e",
	"./event.js": "49d9",
	"./loginhistory.js": "7012",
	"./meeting.js": "7add",
	"./report.js": "19ab",
	"./resource.js": "ba1d",
	"./siteconfig.js": "2750",
	"./student.js": "3ca6",
	"./user.js": "f421"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";